import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Injector, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationApiService } from 'app/service/authentication-api.service';
import { CommonService } from 'app/service/common';
import { LayoutService } from 'app/service/layout.service';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable, Subject } from 'rxjs';
import { ChangePasswordComponent } from 'shared/components/change-password/change-password.component';
import { UserInfoComponent } from 'shared/components/user-info/user-info.component';
import { MenuItemModel, UserModel } from 'shared/definition';
import { MenuModel } from 'shared/definition/menu.model';
import { MessageService, AuthorizationApiService, SpinningService, ThemeService, SignalrService, CodeManagementApiService } from 'shared/services';
import { ContentSizeSubscribeService } from 'app/service/contentsize.subscribe.service';
import { CodeTypeName } from 'shared/consts';
import { SubjectService } from 'app/service/subject.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: 'main-layout.component.html',
  styleUrls: [
    './main-layout.component.scss',
  ],
})
export class MainLayoutComponent implements OnDestroy {
  _navmenuSelected: boolean;
  // 路由打开记录
  selectMenu = {};
  // 选中的
  selectMenu_1: MenuModel;
  // 当前所有菜单
  _menus: any = [];
  // 所有的菜单
  allMenus: MenuItemModel[];
  // 默认选中的索引
  fcSelectedIndex = 0;
  // 选项卡
  fcTabs = [];
  // 单位名称
  companyName = 'admin';
  // 退出登录文字提示是否显示
  siginoutVisible: boolean;
  // 消息侧边栏
  navsideVisible = false;
  // 菜单导航的宽度
  menuWidth = 200;
  // 头像
  avatar = 'assets/img/user.png';

  currentUser: UserModel;
  currentUserName: string;
  permissionData: any = {};
  firstMenu: MenuModel;
  theme: string;
  language: string;
  showAlarm = false;
  isShowEntryPage = () => {
    // return localStorage.getItem('isShowEntryPage') == '1';
    return false;
  };


  /**
   * 切换主题
   */
  changeTheme(theme: string) {
    this.themeService.setTheme(theme);
  }

  /**获取主题*/
  get isDarkTheme() {
    const theme = this.themeService.getTheme();
    return theme === 'dark';
  }
  translation: any = {};

  protected router: Router;
  protected activatedRoute: ActivatedRoute;
  protected mainService: LayoutService;
  protected messageService: MessageService;
  protected modalService: NzModalService;
  protected authenticateService: AuthenticationApiService;
  protected authorizationApi: AuthorizationApiService;
  public spinningService: SpinningService;
  protected themeService: ThemeService;
  protected translate: TranslateService;
  protected i18n: NzI18nService;
  protected httpClient: HttpClient;
  isSpinning$: Observable<boolean>;
  onDestroy$ = new Subject<boolean>();

  bordered$: Observable<boolean>;
  deviceSNInfo: any;

  alarmsNumber: number = 0
  @ViewChild('mmPage', { static: false }) mmPage: any;
  constructor(protected injector: Injector,
    private contentSizeSubscribeService: ContentSizeSubscribeService,
    private codeManagementApiService: CodeManagementApiService,
    private subject: SubjectService,
    private singalr: SignalrService,
  ) {
    this.router = injector.get(Router);
    this.activatedRoute = injector.get(ActivatedRoute);
    this.mainService = injector.get(LayoutService);
    this.messageService = injector.get(MessageService);

    this.modalService = injector.get(NzModalService);
    this.authenticateService = injector.get(AuthenticationApiService);
    this.authorizationApi = injector.get(AuthorizationApiService);
    this.spinningService = injector.get(SpinningService);
    this.themeService = injector.get(ThemeService);
    this.translate = injector.get(TranslateService);
    this.i18n = injector.get(NzI18nService);
    this.httpClient = injector.get(HttpClient);

    this.getCurrentLanguage();
    this.fcTabs = [];
    // 点击左侧导航
    CommonService.subscribe('selectedMenu', (event: any) => {
      if (event) {
        this.selectMenu_1 = event.param;

        const tab = {
          id: this.selectMenu_1?.id,
          index: this.fcTabs.length,
          enabled: false,
          name: this.selectMenu_1?.name,
          close: true,
          icon: this.selectMenu_1?.icon,
          content: this.selectMenu_1,
          refresh: 'Y',
        };
        this.selectedTabMenu(tab);
      }
    });
    setTimeout(() => {
      this.routerChange();
    });
  }

  getCurrentLanguage() {
    this.language = window.localStorage.getItem('language');
    document.title = this.translate.instant('Common.SystemName');
  }

  ngOnInit(): void {
    this.currentUserName = localStorage.getItem('userName');
    if (!localStorage.getItem('token')) {
      this.router.navigate(['login']);
    }

    const theme = this.themeService.getTheme();
    this.themeService.setTheme(theme);
    if(localStorage.getItem('token')){
      this.setCodeCache();
    }
  }
  setCodeCache() {
    this.codeManagementApiService.setCodeCache(CodeTypeName.DeviceType);
    this.codeManagementApiService.setCodeCache(CodeTypeName.OperationType);
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.contentSizeSubscribeService.sizeChange();
  }

  /**
   * @description: 选中选项卡导航
   * @param {type}
   * @return:
   */
  selectedTabMenu(tabMenu: any) {
    let refresh = 'Y';
    // 判断路由是否打开过，如果已打开不刷新，反之，刷新
    refresh =
      this.selectMenu[tabMenu.content.enCode] &&
        this.selectMenu[tabMenu.content.enCode] !== ''
        ? 'N'
        : 'Y';
    if (!this.selectMenu[tabMenu.content.enCode]) {
      // 将该路由存放在路由打开记录中
      this.selectMenu[tabMenu.content.enCode] = tabMenu.content.enCode;
    } else {
      refresh = 'N';
    }
    this.mainService.navMenu(this.router, tabMenu.content, refresh);
  }

  routerChange() {
    this.router.events.subscribe((data) => {
      if (data instanceof NavigationStart) {
        this.messageService.showLoading();
        this.closeAlarmTable();
      }
      if (data instanceof NavigationEnd) {
        this.messageService.hideLoading();
      }
    });
  }

  checkSettingLayout() {
    var projectId = localStorage.getItem('projectId');
    if(this.router.url.indexOf('setting-layout') == -1 && this.router.url.indexOf('login') == -1 && !projectId) {
      this.router.navigate(['/setting-layout']);
    }
  }

  /**
   * 个人信息
   */
  openUserInfo() {
    this.modalService.create({
      nzTitle: this.translation.UserSetting,
      nzContent: UserInfoComponent,
      nzMaskClosable: false,
    });
  }

  /**
   * 修改密码
   */
  changPwd() {
    this.modalService.create({
      nzTitle: this.translation.ModifyPassword,
      nzContent: ChangePasswordComponent,
      nzMaskClosable: false,
    });
  }

  /**
   * 退出登录
   */
  siginout() {
    this.siginoutVisible = false;
    localStorage.removeItem('token');
    localStorage.removeItem('reportServerBaseUrl');
    localStorage.removeItem('userinfo');
    localStorage.removeItem('permissions');
    this.router.navigate(['/login']);
  }

  closeAlarmTable() {
    this.showAlarm = false;
  }

}